import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as bootstrap from 'bootstrap'
import App from '../components/App'
import './application.scss'

// Make Bootstrap available globally for data-bs-* attributes
window.bootstrap = bootstrap

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('react-root')

  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    )
  }
})
